import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 14.665a6.665 6.665 0 1 0 0-13.33 6.665 6.665 0 0 0 0 13.33m3.274-8.605a.76.76 0 0 1 0 1.071l-3.407 3.406a.757.757 0 0 1-1.07 0l-1.802-1.8a.757.757 0 1 1 1.072-1.071L7.332 8.93l2.87-2.871a.757.757 0 0 1 1.072 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })